// extracted by mini-css-extract-plugin
export default {"icon":"style--icon--d4849c","new":"style--new--b94290","rescheduled":"style--rescheduled--4acc68","cancelled":"style--cancelled--2290b7"};